/**
 * Master Classes page: Мастер-классы — творчество, развитие и радость.
 * Static content, events to be added later.
 */

import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Layout } from "../../components/layout/index.ts";
import { IconChevronRight } from "../../components/Icons.tsx";
import { getTelegram } from "../../lib/telegram.ts";

const BODY_TEXT = `Мастер-классы — это пространство творчества, где дети и взрослые учатся новому, пробуют свои силы и создают что-то своими руками.

Рисование, рукоделие, музыка, кулинария — мы проводим разные форматы для всей семьи.

Приходите на мастер-классы: здесь царит атмосфера радости, общения и совместного творчества.`;

function buildImageUrl(url: string | null | undefined): string | null {
  if (!url?.trim()) return null;
  if (url.startsWith("http")) return url;
  return url.startsWith("/") ? url : `/${url}`;
}

export function MasterClassesPage() {
  const navigate = useNavigate();
  const tg = getTelegram();
  const imageUrl = buildImageUrl("/content/master-class.png");

  useEffect(() => {
    if (!tg) return;
    tg.BackButton.show();
    const handleBack = () => {
      if (window.history.length > 1) {
        navigate(-1);
      } else {
        navigate("/");
      }
    };
    tg.BackButton.onClick(handleBack);
    return () => {
      tg.BackButton.offClick(handleBack);
      tg.BackButton.hide();
    };
  }, [tg, navigate]);

  return (
    <Layout>
      <h1 className="text-xl font-bold text-slate-800 mb-4">Мастер-классы</h1>

      {/* Hero image */}
      {imageUrl ? (
        <div className="aspect-[4/3] overflow-hidden rounded-2xl mb-4 shadow-sm border border-slate-100 ring-1 ring-slate-200/50 bg-slate-100">
          <img src={imageUrl} alt="" className="w-full h-full object-cover" />
        </div>
      ) : null}

      {/* Description */}
      <div className="rounded-2xl overflow-hidden bg-white/95 shadow-sm p-4 xs:p-5 border border-slate-100">
        <p className="text-slate-600 text-sm leading-relaxed whitespace-pre-wrap prose prose-slate prose-sm max-w-none">
          {BODY_TEXT}
        </p>
      </div>

      {/* Placeholder for future events */}
      <div className="mt-6 rounded-2xl overflow-hidden bg-white/80 backdrop-blur-sm shadow-sm p-6 text-center border border-slate-100">
        <p className="text-slate-500 text-sm font-medium uppercase tracking-wider">
          Скоро
        </p>
        <p className="text-slate-600 text-sm mt-1">
          Мероприятия появятся здесь
        </p>
      </div>

      <div className="mt-6">
        <Link
          to="/schedule"
          className="flex items-center justify-between gap-3 py-4 px-4 rounded-xl bg-white/95 shadow-sm border border-slate-100 active:bg-slate-50 transition-colors no-underline text-inherit"
        >
          <span className="font-medium text-slate-800">
            Всё расписание на неделю
          </span>
          <IconChevronRight className="w-5 h-5 text-slate-300 flex-shrink-0" />
        </Link>
      </div>

      <div className="h-4" />
    </Layout>
  );
}
